var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-theme", attrs: { id: "app" } },
    [_c("TheGlobalNotifications"), _c("RouterView"), _c("AppModalForm")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }